module.exports = __webpack_public_path__ + "img/ic_layers.9aa178c4.svg";